module.exports = __webpack_public_path__ + "img/empty-img-default.f339004d.svg";